@if (dataLoaded) {
    <div menuSystem [cerrixTab]="tab" class="mailmessage-detail">
        <div [attr.name]="header" menuicon="fas fa-mail-bulk" menusystemsubmenu>
            <div
                name="Mailmessages"
                class="mailmessage-screens"
                menuicon="fas fa-envelope"
                menusystemsubmenu
            >
                @if (permService.permissions.IsApplicationAdmin) {
                    <div
                        name="Application"
                        menuicon="fas fa-unlock-alt"
                        menuItemId="application-mail"
                        menusystemitem
                    >
                        <uc-mailmessages-overview
                            [module]="moduleTypes.COMMON"
                        ></uc-mailmessages-overview>
                    </div>
                }

                @if (permService.permissions.MailMessages.IsBimMailAdministrator) {
                    <div
                        name="Business Improvement"
                        menuicon="fas fa-tasks"
                        menuItemId="bi-mail"
                        menusystemitem
                    >
                        <uc-mailmessages-overview
                            [module]="moduleTypes.BIM"
                        ></uc-mailmessages-overview>
                    </div>
                }
                @if(permService.permissions.MailMessages.IsRiskMailAdministrator) {
                    <div
                        name="Risk"
                        menuicon="fas fa-exclamation-triangle"
                        menuItemId="risk-mail"
                        menusystemitem
                    >
                        <uc-mailmessages-overview
                            [module]="moduleTypes.ORM"
                        ></uc-mailmessages-overview>
                    </div>
                }
                @if (permService.permissions.MailMessages.IsControlMailAdministrator) {
                    <div
                        name="Control"
                        menuicon="fas fa-shield-alt"
                        menuItemId="control-mail"
                        menusystemitem
                    >
                        <uc-mailmessages-overview
                            [module]="moduleTypes.Controls"
                        ></uc-mailmessages-overview>
                    </div>
                }
                @if (permService.permissions.MailMessages.IsEventMailAdministrator) {
                    <div name="Event" menuicon="fas fa-bolt" menuItemId="event-mail" menusystemitem>
                        <uc-mailmessages-overview
                            [module]="moduleTypes.LER"
                        ></uc-mailmessages-overview>
                    </div>
                }
                @if (permService.permissions.MailMessages.IsFormMailAdministrator) {
                    <div
                        name="Forms"
                        menuicon="fas fa-file-alt"
                        menuItemId="form-mail"
                        menusystemitem
                    >
                        <uc-mailmessages-overview
                            [module]="moduleTypes.FRM"
                        ></uc-mailmessages-overview>
                    </div>
                }
                @if (permService.permissions.MailMessages.IsInviteMailAdministrator) {
                    <div
                        name="Invite"
                        menuicon="fas fa-paper-plane"
                        menuItemId="invite-mail"
                        menusystemitem
                    >
                        <uc-mailmessages-overview
                            [module]="moduleTypes.CI"
                        ></uc-mailmessages-overview>
                    </div>
                }
                @if (permService.permissions.MailMessages.IsNavigatorMailAdministrator) {
                    <div
                        name="Navigators"
                        menuicon="fad fa-sitemap"
                        menuItemId="navigator-mail"
                        menusystemitem
                    >
                        <uc-mailmessages-overview
                            [module]="moduleTypes.NAV"
                        ></uc-mailmessages-overview>
                    </div>
                }
                @if (permService.permissions.MailMessages.IsAuditMailAdministrator) {
                    <div
                        name="Audit"
                        menuicon="fal fa-clipboard-list-check"
                        menuItemId="audit-mail"
                        menusystemitem
                    >
                        <uc-mailmessages-overview
                            [module]="moduleTypes.AUDIT"
                        ></uc-mailmessages-overview>
                    </div>
                }
                @if (permService.permissions.MailMessages.IsTaskMailAdministrator) {
                    <div
                        name="Tasks"
                        menuicon="fad fa-list-ol"
                        menuItemId="tasks-mail"
                        menusystemitem
                    >
                        <uc-mailmessages-overview
                            [module]="moduleTypes.Tasks"
                        ></uc-mailmessages-overview>
                    </div>
                }
            </div>
            <div name="Notifications" menuicon="fad fa-bells" menusystemsubmenu>
                @if (permService.permissions.MailMessages.IsApplicationMailAdministrator) {
                    <div
                        name="Application"
                        menuicon="fas fa-unlock-alt"
                        menuItemId="application-mail"
                        menusystemitem
                    >
                        <uc-notification-overview
                            [module]="moduleTypes.COMMON"
                        ></uc-notification-overview>
                    </div>
                }
                @if (permService.permissions.MailMessages.IsControlMailAdministrator) {
                    <div
                        name="Controls"
                        menuicon="fas fa-shield-alt"
                        menuItemId="control-notification-mail"
                        menusystemitem
                    >
                        <uc-notification-overview
                            [module]="moduleTypes.Controls"
                        ></uc-notification-overview>
                    </div>
                }
                @if (permService.permissions.MailMessages.IsBimMailAdministrator) {
                    <div
                        name="Measures of improvement"
                        menuicon="fas fa-tasks"
                        menuItemId="moi-notification-mail"
                        menusystemitem
                    >
                        <uc-notification-overview
                            [module]="moduleTypes.IM"
                        ></uc-notification-overview>
                    </div>
                }
                @if (permService.permissions.MailMessages.IsFormMailAdministrator) {
                    <div
                        name="Forms"
                        menuicon="fas fa-file-alt"
                        menuItemId="form-notification-mail"
                        menusystemitem
                    >
                        <uc-notification-overview
                            [module]="moduleTypes.FRM"
                        ></uc-notification-overview>
                    </div>
                }
                @if (permService.permissions.MailMessages.IsThirdPartyMailAdministrator) {
                    <div
                        name="Third party"
                        menuicon="fas fa-handshake"
                        menuItemId="tp-notification-mail"
                        menusystemitem
                    >
                        <uc-notification-overview
                            [module]="moduleTypes.TP"
                        ></uc-notification-overview>
                    </div>
                }
                @if (permService.permissions.MailMessages.IsNavigatorMailAdministrator) {
                    <div name="Navigators" menuicon="fad fa-sitemap" menusystemitem>
                        <uc-notification-overview [module]="moduleTypes.NAV">
                        </uc-notification-overview>
                    </div>
                }
                @if (permService.permissions.MailMessages.IsTaskMailAdministrator) {
                    <div name="Tasks" menuicon="fad fa-list-ol" menusystemitem>
                        <uc-notification-overview [module]="moduleTypes.Tasks">
                        </uc-notification-overview>
                    </div>
                }
            </div>
            <div name="Periodic Notifications" menuicon="fad fa-bells" menusystemsubmenu>
                @if (permService.permissions.MailMessages.IsBimMailAdministrator) {
                    <div
                        name="Measures of improvement"
                        menuicon="fas fa-tasks"
                        menuItemId="moi-periodic-notification-mail"
                        menusystemitem
                    >
                        <uc-periodic-notification-overview
                            [module]="moduleTypes.IM"
                        ></uc-periodic-notification-overview>
                    </div>
                }
                @if (
                    useIncidents && permService.permissions.MailMessages.IsEventMailAdministrator
                ) {
                    <div
                        name="Incidents"
                        menuicon="fas fa-bolt"
                        menuItemId="incidents-periodic-notification-mail"
                        menusystemitem
                    >
                        <uc-periodic-notification-overview
                            [module]="moduleTypes.Incidents"
                        ></uc-periodic-notification-overview>
                    </div>
                }
            </div>
            @if (permService.permissions.IsApplicationAdmin || hasViewEmailsDataAccess()) {
                <div name="Sent Mails" menuicon="fad fa-history" menusystemsubmenu>
                    @if (permService.permissions.IsApplicationAdmin) {
                        <div
                            name="Sent mails"
                            class="sent-mails"
                            menuItemId="sent-mails"
                            menuicon="fas fa-envelope"
                            menusystemitem
                        >
                            <uc-sentnotification-overview
                                [parentTab]="tab"
                                #sentmails
                            ></uc-sentnotification-overview>
                        </div>
                    }
                    @if (hasViewEmailsDataAccess()) {
                        <div
                            name="Incident sent mails"
                            class="incident-sent-mails"
                            menuItemId="incident-sent-mails"
                            menuicon="fas fa-bolt"
                            menusystemitem
                        >
                            <incident-sent-emails></incident-sent-emails>
                        </div>
                    }
                </div>
            }
            @if (permService.permissions.IsApplicationAdmin) {
                <div
                    name="Notification Settings"
                    class="notification-settings"
                    menuItemId="notification-settings"
                    menuicon="fas fa-cogs"
                    menusystemitem
                >
                    <notification-settings
                        [parentTab]="tab"
                        #notificationSettings
                    ></notification-settings>
                </div>
            }
        </div>
    </div>
}
